import axios from "axios";
import { store } from "@/store/store";

let api_url = process.env.VUE_APP_API;

// let url = window.location.href
// let prefix = new URL(url).host.split(".")[0];
// let remainder = new URL(url).pathname
// if ( prefix === 'web') {
//   prefix = new URL(url).host.split(".")[1];
//    api_url = `https://api.${prefix}.edclearn.com/v1`
// }
// const instance = axios.create({
//   //   baseURL:
//   //     window.location.hostname == "localhost"
//   //       ? process.env.VUE_APP_API
//   //       : "https://api.edc.hostville.website/v1",
//   // });
//   baseURL: api_url,
//   // headers: {
//   //   'App_Key' : 'TESTING'
//   // }
// });

const instance = axios.create();

const backup_api_routes = ['tenant/user/bulk/create', '/tenant/course/learner/mycourses', '/tenant/course/learner/mycourses?per_course_view=true'];
const backup_api_routes2 = []; //['tenant/growth_plan/learner/course-list/show'];

// request interceptor
instance.interceptors.request.use(
  (config, reqAuth) => {
    return config;
  },
  (error) => {}
); 
class Api {
  static async get(url, requireAuth = false) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API : process.env.VUE_APP_API;
    if ( backup_api_routes.includes(url) ) {
      base_url = process.env.VUE_APP_API_BACKUP;
    }
    if ( backup_api_routes2.includes(url) ) {
      base_url = process.env.VUE_APP_API_BACKUP2;
    }
    instance.defaults.baseURL = base_url;

    try {
      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
      };
      let response = requireAuth
        ? await instance.get(url, config)
        : await instance.get(url);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async post(url, payload, requireAuth = false) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API : process.env.VUE_APP_API;
    if ( backup_api_routes.includes(url) ) {
      base_url = process.env.VUE_APP_API_BACKUP;
    }
    instance.defaults.baseURL = base_url;

    try {
      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
      };
      let response = requireAuth
        ? await instance.post(url, payload, config)
        : await instance.post(url, payload);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async patch(url, payload, requireAuth = false) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API : process.env.VUE_APP_API;
    instance.defaults.baseURL = base_url;
    try {
      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
      };

      let response = requireAuth
        ? await instance.patch(url, payload, config)
        : await instance.patch(url, payload);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async put(url, payload = {}, requireAuth = false) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API : process.env.VUE_APP_API;
    instance.defaults.baseURL = base_url;
    try {

      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
      };

      let response = requireAuth
        ? await instance.put(url, payload, config)
        : await instance.put(url, payload);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async patch(url, payload = {}, requireAuth = false) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API_BACKUP : process.env.VUE_APP_API;
    instance.defaults.baseURL = base_url;
    try {
      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
      };
      let response = requireAuth
        ? await instance.patch(url, payload, config)
        : await instance.patch(url, payload);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async delete(url, payload = {}, requireAuth = true) {
    let base_url = localStorage.getItem("use-backup-api") !== null && localStorage.getItem("use-backup-api") == "true" ? process.env.VUE_APP_API_BACKUP : process.env.VUE_APP_API;
    instance.defaults.baseURL = base_url;
    try {
      let config = {
        headers: {
          Authorization: `Bearer ${store.state.auth.token}`,
        },
        data: payload,
      };
      let response = requireAuth
        ? await instance.delete(url, config)
        : await instance.delete(url, { data: payload });
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default Api;
